import { useAuth0 } from '@auth0/auth0-react';
import {
    Backdrop,
    Box,
    Fade,
    Grid,
    Modal,
    styled,
    Typography,
    useMediaQuery,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { fetchProfile } from '../../redux/ProfileSlice';
import { storeToken } from '../../redux/TokenSlice';
import SideDrawer from './SideDrawer';
import ToolBar from './ToolBar';

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
const withWidth = () => WrappedComponent => props =>
    <WrappedComponent {...props} width="xs" />;
const drawerWidth = 240;
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: '25px',
    boxShadow: 24,
    p: 4,
};

const NavDiv = styled('div')(({ theme }) => ({
    //height: '110px',
    height: '80px',
    [theme.breakpoints.up('md')]: {
        ml: `${drawerWidth}px`,
        marginTop: '-80px',
    },
    [theme.breakpoints.up('xs')]: {
        ml: `${drawerWidth}px`,
        marginTop: '-80px',
    },
}));

const NavBar = props => {
    const location = useLocation();
    let size = props.width;
    let smallSize = false;
    if (size === 'sm' || size === 'xs') {
        smallSize = true;
    }

    const [open, setOpen] = useState(false);
    const [sideDrawer, setSideDrawer] = useState(true);
    const [schoolAdmin, setSchoolAdmin] = useState(false);
    const [schoolNoPermission, setSchoolNoPermission] = useState(false);
    const [state, setState] = useState({
        username: '',
        profile: {},
        ackronym: '',
        type: '',
        profileImage: '',
    });
    const handleOpen = () => {
        setOpen(true);
        setSideDrawer(false);
    };
    const handleClose = () => setOpen(false);

    const {
        getAccessTokenSilently,
        user,
        isAuthenticated,
        loginWithRedirect,
        logout,
    } = useAuth0();
    const history = useHistory();

    const dispatch = useDispatch();
    const profile = useSelector(state => state.profile.profile);
    const profileStatus = useSelector(state => state.profile.status);
    const tokenObj = useSelector(state => state.token.token);
    const tokenStatus = useSelector(state => state.token.status);

    useEffect(() => {
        console.log('UseEffect called', profileStatus);
        if (profileStatus === 'succeeded' && isAuthenticated) {
            if (profile.Data.Count > 0) {
                if (
                    tokenObj.permissions.find(perm => perm === 'create:booking')
                ) {
                    setSchoolAdmin(true);
                } else if (
                    !tokenObj.permissions.find(
                        perm => perm === 'read:booking'
                    ) &&
                    profile.Data.Items[0].type === 'School'
                ) {
                    setSchoolNoPermission(true);
                }
                let profileImage = user.picture;
                if (
                    typeof profile.Data.Items[0].profileImage === 'undefined' ||
                    profile.Data.Items[0].profileImage === ''
                ) {
                    profileImage = user.picture;
                } else {
                    profileImage = profile.Data.Items[0].profileImage;
                }

                setState({
                    username: profile.Data.Items[0].firstName,
                    ackronym:
                        profile.Data.Items[0].firstName.charAt(0) +
                        profile.Data.Items[0].lastName.charAt(0),
                    type: profile.Data.Items[0].type,
                    profileImage: profileImage,
                });
            }
        } else if (profileStatus === 'idle' && isAuthenticated) {
            async function dispatchProfileFromStore() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });

                dispatch(storeToken(token));
                dispatch(fetchProfile(token));
            }
            dispatchProfileFromStore();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileStatus, profile.Data, tokenStatus]);

    // if (isAuthenticated) {
    //     if (state.profileImage == undefined || state.profileImage == '') {
    //         setProfilePic(user.picture);
    //     }
    // }

    useEffect(() => {
        return history.listen(location => {
            setSideDrawer(false);
        });
    }, [history]);

    const handleDrawerToggleClick = () => {
        setSideDrawer(prevDrawerState => !prevDrawerState);
    };

    const handleBackdropClick = () => {
        setSideDrawer(false);
    };

    const isTabletAndAbove = useMediaQuery(theme => theme.breakpoints.up('md'));
    return (
        <NavDiv
            sx={{
                display: location.pathname === '/' ? 'none' : 'auto',
            }}
        >
            <ToolBar
                handleDrawerToggleClick={handleDrawerToggleClick}
                handleLogin={handleOpen}
                loginWithRedirect={loginWithRedirect}
                schoolAdmin={schoolAdmin}
                profileLoaded={profileStatus}
                isAuthenticated={isAuthenticated}
                profile={state}
                logout={logout}
                profileExists={profile.Data.Count}
                schoolNoPermission={schoolNoPermission}
            />
            {smallSize && (
                <SideDrawer
                    show={isTabletAndAbove}
                    handleClose={handleDrawerToggleClick}
                    handleLogin={handleOpen}
                    loginWithRedirect={loginWithRedirect}
                    schoolAdmin={schoolAdmin}
                    profileLoaded={profileStatus}
                    isAuthenticated={isAuthenticated}
                    profile={state}
                    logout={logout}
                    profileExists={profile.Data.Count}
                    schoolNoPermission={schoolNoPermission}
                />
            )}

            {/* // <Modal
            //     open={open}
            //     onClose={handleClose}
            //     aria-labelledby="modal-modal-title"
            //     aria-describedby="modal-modal-description"
            // >
            //     <Fade in={open}>
            //         <Box sx={style}>
            //             <Typography variant="h5" sx={{ textAlign: 'center' }}>
            //                 USER TYPE
            //             </Typography>
            //             <Grid container sx={{ justifyContent: 'center' }}>
            //                 <Grid item>
            //                     <Link to="/signup" />
            //                 </Grid>
            //                 <Grid item>
            //                     <Link to="/signup" />
            //
            //                 </Grid>
            //             </Grid>
            //
            //         </Box>
            //     </Fade>
            // </Modal>

          {smallSize && (
                <Backdrop
                    onClick={handleBackdropClick}
                    open={sideDrawer}
                    sx={{ zIndex: 100 }}
                />
            )}
          */}
        </NavDiv>
    );
};

export default withWidth()(NavBar);
